import moment from 'moment';

const isWeekday = date => date.isoWeekday() <= 5;

function nextWeekday(date) {
    let _date = moment(date);
    while (!isWeekday(_date)) {
        _date = _date.add(1, 'days');
    }
    return _date;
}

function addWeekdays(date, days) {
    date = moment(date);
    while (days > 0) {
        date = date.add(1, 'days');
        if (isWeekday(date)) {
            days -= 1;
        }
    }
    return date;
}

export default ngModule => {
    ngModule.controller('ComparatorStep3CtrlHIF', function ($scope, $controller, AonConfig) {
        // This is black magic that allows us to use another controller (Hambs) as a parent of
        // this one, without having to nest with routing or templates...
        // Taken from:
        // https://stackoverflow.com/questions/18461263/can-an-angularjs-controller-inherit-from-another-controller-in-the-same-module
        const hambs = $controller('ComparatorStep3CtrlHAMBS as hambsCtrl', { $scope: $scope });
        angular.extend(this, hambs);

        const ctrl = $scope.$parent.$parent.ctrl;

        const originalDebitDateDisabled = ctrl.debitDateDisabled;
        ctrl.debitDateDisabled = (date, mode) => {
            // Disable weekends
            if (date.getDay() == 0 || date.getDay() == 6) {
                return true;
            }
            // Disable 29, 30, 31 for some payment frequencies
            const frequencies = AonConfig.jsConstants.PaymentFrequencies;
            const constrainFrequencies = [
                frequencies['Monthly'],
                frequencies['Quarterly'],
                frequencies['Half Yearly'],
            ];
            const paymentFreq = _.get(ctrl.application, 'payment.frequency');
            const isLast3Days = [29, 30, 31].includes(date.getDate());
            if (constrainFrequencies.includes(paymentFreq) && isLast3Days) {
                return true;
            }
            return originalDebitDateDisabled(date, mode);
        };

        ctrl.updateDebitDate = () => {
            const today = moment();
            const joinDate = moment(_.get(ctrl.application, 'payment.join_date', moment()));
            const joinDateDiff = Math.round(joinDate.diff(today, 'days', true));
            const minDebitDate = nextWeekday(joinDateDiff <= 3 ? addWeekdays(joinDate, 3) : moment(joinDate));
            const maxDebitDate = addWeekdays(joinDate, 20);

            const payment = $scope.$parent.ctrl.application.payment;
            payment.debit_date = minDebitDate;
            ctrl.debit_date_minimum = minDebitDate;
            ctrl.debit_date_maximum = maxDebitDate;
        };
        ctrl.updateDebitDate();
    });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-hif.js